import { useLayoutEffect, useState } from 'react'

let debounce = null

const screenSize = () => {
  const w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    width = w.innerWidth || e.clientWidth || g.clientWidth,
    height = w.innerHeight || e.clientHeight || g.clientHeight

  return { height, width }
}

const useWindowSize = (options = {}) => {
  const opts = {
    ...{
      debounce: 500
    },
    ...options
  }
  const [size, setSize] = useState([screenSize().width, screenSize().height])

  useLayoutEffect(() => {
    function updateSize() {
      if (debounce) {
        clearTimeout(debounce)
      }

      debounce = setTimeout(() => {
        const size = screenSize()
        setSize([size.width, size.height])
      }, opts.debounce)
    }

    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return size
}

export default useWindowSize
